import { render, staticRenderFns } from "./app.vue?vue&type=template&id=4c9b6054&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style1 from "./app.vue?vue&type=style&index=1&id=4c9b6054&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b6054",
  null
  
)

export default component.exports